import { HighlightedCard, Box } from '@edreamsodigeo/prisma-design-system';
import React, { FC } from 'react';
import { colors } from './constants/designTokens';

export const DealCard: FC = ({ children, ...props }) => {
  const gradient = colors.deal.backgroundGradient;
  return (
    <Box
      backgroundColor={gradient}
      p={'tiny'}
      sx={{ position: 'relative', zIndex: 2 }}
    >
      <HighlightedCard
        sx={{
          border: 'none !important',
        }}
        borderRadius={2}
        {...props}
      >
        {children}
      </HighlightedCard>
    </Box>
  );
};
